import React from 'react';
import styled from 'styled-components';
import { lightGreenColor } from 'js/config/style';
import AppUser from "js/stores/AppUser"
import { observer } from 'mobx-react';

const StyledUserLogoIcon = styled.div`
  position: relative;
  top: -1px;
  width: ${({ width }) => width || '2.625rem'};
  height: 2.625rem;

  .background {
    fill: ${({ color }) => color || lightGreenColor};
  }
  .user {
    fill: ${({ background }) => background || 'white'};
  }

  img {
    border-radius: 50px;
    width: 2.625rem;
    height: 2.625rem;
    background-color: rgba(0, 22, 255, 0.2);
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    margin-top: -3px;
  }
`;

const UserLogoIcon = observer((props) => {
  return (
    <StyledUserLogoIcon {...props}>
      {AppUser.avatar ? (
        <img src={AppUser.avatar} alt="Avatar" />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.4 114.4">
          <circle id="circle" className="background" cx="57.5" cy="57.5" r="55.8" />
          <ellipse id="body" className="user body" cx="57.5" cy="80.3" rx="31.7" ry="15.2" />
          <circle id="head" className="user head" cx="57.5" cy="42.2" r="19" />
        </svg>
      )}
    </StyledUserLogoIcon>
  );
});

export default UserLogoIcon;
